import React from "react"
import { Link, graphql } from "gatsby"
import TwoCol from "gatsby-theme-wirehead-bulma/src/twocol"
import Layout from "gatsby-theme-wirehead-bulma/src/layout"
import GalleryList from "../components/gallerylist"
import SEO from "gatsby-theme-wirehead-bulma/src/seo"
import { MDXRenderer } from "gatsby-plugin-mdx"

export default function PageTemplate({ data, location, pageContext }) {
  const { mdx, photos: { photoEdges }, allSitePage } = data
  const { body } = mdx

  var pages = data.allSitePage.edges.map(article => {
    return (
      <li>
        <Link
          to={article.node.path}
          key={article.node.path}
          className="navbar-item"
        >
          {article.node.context.title}
        </Link>
      </li>
    )
  })

  const Photos = photoEdges.map(edge => {
    return (
      <div className="card mbox">
      <div className="card-image">
      <figure className="image">
      <Link to={"/" + edge.node.slug} key={edge.node.slug}><img srcSet={edge.node.image.srcSet} alt={edge.node.frontmatter.title}/></Link>
      </figure>
      </div>
      <div class="card-content">
      <Link to={edge.node.slug} key={edge.node.slug}>{edge.node.frontmatter.title}</Link>
      </div>
      </div>
    );
  })

  return (
    <Layout posted={pageContext.date} updated={pageContext.updated}>
      <SEO
        title={pageContext.title}
        pathname={location.pathname}
        description={pageContext.excerpt} />
    <section className="section">
    <div>
    <TwoCol
        left={
          <div className="content">
            <h1 className="title">{pageContext.title}</h1>
            <MDXRenderer pages={allSitePage}>{body}</MDXRenderer>
            <div>
            {Photos}
            </div>
          </div>
        }
        right={
          <aside className="menu">
          <p className="menu-label">Galleries</p>
          <GalleryList />
          </aside>
        }
      />
    </div>
    </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($id: String, $path: String) {
    mdx(id: { eq: $id }) {
      body
      id
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        type
        description
      }
      excerpt(pruneLength: 300)
    }
    photos: allMdx(filter: {frontmatter: {hidden: {ne: true}, parent: {eq: $path}}} ) {
      photoEdges: edges {
        node {
          id
          slug
          frontmatter {
            parent
            title
          }
          image {
            id
            key
            maxSize
            size
            srcSet
            srcPath
            width
            height
            sqSrcSet
            srcSet
          }
        }
      }
    }
    allSitePage(filter: { context: { parent: { eq: $path } } }) {
      edges {
        node {
          context {
            id
            depth
            parent
            title
          }
          path
        }
      }
    }
  }
`
